rdefine('app/events/times',['backbone','text!events/times.html','app/components/options','app/events/event-time-row'], function(Backbone, template, Options, EventsTimeRow) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'events-month-times',
        bindings:{
            el:{
                toggle:'model.active'
            },
            h5:{
                text:{data:'model.id',processor:function(date){
                    return moment(date).format("DD MMM YYYY");
                    }}
            },
            '.addTime':{
                toggle:{
                    data:'state.add',
                    processor:function(add) {
                        return !add;
                    }

                }
            },
            '.event-times-add .baloon':{
                toggle:'state.add'
            },
            '.doAddTime':{
                enabled:{
                    data:['state.cadds','state.cadde'],
                    processor: function(a,b) {
                        if(!a || !b || a.length < 5 || b.length < 5) {
                            return false;
                        }
                        a = a.split(":");
                        b = b.split(":");
                        a = a[0]*100 + a[1];
                        b = b[0]*100 + b[1];

                        return a <= b;
                    }
                }
            },
            '.clone-link':{
                toggle:{
                    data:'state.times'
                }
            },
            '.start-time-add input':{
                value:'state.cadds'
            },
            '.end-time-add input':{
                value:'state.cadde'
            },
            '.event-times-list':{
                collection:{
                    col:'times',
                    view:EventsTimeRow
                }
            }
        },
        events:{
            'click .addTime':'addTime',
            'click .cancelAddTime':'cancelTime',
            'click .clone-link button':'onCloneLink',
            'click .remove-link button':'onDeleteLink',
            'focus input':'onFocus',
            'blur input':'onBlur',
            'click .doAddTime':'onAddTimeClick'
        },
        initialize:function(options) {
            this.state = new Backbone.Ribs.Model({add:false, cadds:'',cadde:'', times:0, cadderr:null});
            this.state.on("change:cadds",_.bind(this.onAddStart,this));
            this.state.on("change:cadde",_.bind(this.onAddStart,this));
            this.times = new Backbone.Ribs.Collection([], {model:Backbone.Ribs.Model});
            this.times.on('add reset remove', function() {
                this.state.set('times',this.times.models.length);
            }.bind(this));
            this.times.on('time-remove', _.bind(function(removed) {
                this.model.removeTime(removed.attributes);
            },this));
            this.times.on('time-update', _.bind(function(old,inew) {
                this.model.updateTime(old,inew);
            },this));
            this.model.on("change:times", _.bind(this.updateFromModel,this));
            this.updateFromModel();
            this.$el.html(Template7.compile(template)());
            this.$el.find("input.times-picker").mask("00:00",{selectOnFocus:true,onComplete:this.onAddComplete.bind(this)}).blur();
        },
        updateFromModel:function(){
            this.times.reset(this.model.get('times') || []);
        },
        addTime: function() {
            this.state.set('add',true);
        },
        cancelTime: function() {
            this.state.set({
                add:false,
                cadds:'',
                cadde:''
            });
        },
        onDeleteLink:function() {
            this.model.collection.disable(this.model.get('id'));
        },
        onFocus:function(e) {
            var t= $(e.target);
            t.attr("placeholder","xx:xx");
        },
        onBlur:function(e) {
            var t= $(e.target);
            t.attr("placeholder",t.attr("placeholder-ex"));
            if(t.val().length<5) {
                t.val("");
            }
        },
        onAddComplete:function(){

        },
        onAddStart:function() {
            var s = this.state.get('cadds','00:00') || '00:00';
            s = s.split(":");
            if(s[1]>59) {
                s[1] = 59;
                this.state.set('cadds',s[0]+":59");
            }
            s = s[0]*100 + +s[1];
            var e = this.state.get('cadde') || '00:00';
            e = e.split(":");
            if(e[1]>59) {
                e[1] = 59;
                this.state.set('cadds',e[0]+":59");
            }
            e = e[0]*100 + +e[1];
            if(s<0) {
                this.state.set('cadds','00:00');
            }
            if(e<0) {
                this.state.set('cadde','00:00');
            }
            if(s>2359) {
                this.state.set('cadds','23:59');
            }
            if(e>2359) {
                this.state.set('cadde','23:59');
            }

            if(e<s) {
                this.state.set('cadde',this.state.get('cadds'));
            }
        },
        onAddTimeClick: function() {
            var s = this.state.get('cadds','00:00') || '00:00';
            var st = s.split(":");
            if(st[1]>59) {
                st[1] = 59;
            }
            st = st[0]*100 + +st[1];
            var e = this.state.get('cadde') || '00:00';
            var et = e.split(":");
            if(et[1]>59) {
                et[1]=59;
            }
            et = et[0]*100 + +et[1];
            this.times.add({from:st,end:et});
            this.state.set({cadds:'',cadde:'',add:false});
            this.model.addTime({from:st,end:et});
        }
    });
});